import { Box, Image, Text } from "@chakra-ui/react";

const switchRender = (id) => {

    const renderObject = {
        0: <Image src = 'images/medal1.svg'  width='25px' height='25px' />,//<MedalForFirst width='25px' height='25px' />,
        1:  <Image src = 'images/medalfor2.svg'  width='25px' height='25px' />,//<MedalForSecond width='25px' height='25px' />,
        2: <Image src = 'images/medalfor3.svg'  width='25px' height='25px' />
    }
    return renderObject[id] ||
        < Text
            fontSize='16px'
            color='#000000'
            fontWeight='600'
            style={{ fontFamily: 'Mulish, sans-serif' }}
        >
            {id + 1}
        </Text>
    
}

export default function Rank({ id }) {
    return (
        <Box w='20%' d='flex' justifyContent='center' alignItems='center' mr='1rem' py='0.5rem'>
            {switchRender(id)}
        </Box>
    )
}